import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import './SquareButton.sass';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

let squareButtonInstanceId = 0;

class SquareButton extends Component {
  static defaultProps;

  constructor(props) {
    super(props);
    squareButtonInstanceId += 1;
    this.inputId = props.id || `${props.name || 'square-button'}-${squareButtonInstanceId}`;
  }

  handleClick = (e) => {
    e.stopPropagation();
    !this.props.disabled &&
      this.props.change(this.props.name, this.props.setValue, this.props.data);
  };

  render() {
    const wrapperClassName = [
      'square-button',
      this.props.class,
      this.props.disabled ? 'disabled-button' : '',
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <>
        <div
          id={this.props.id || undefined}
          className={wrapperClassName}
          style={this.props.style}
        >
          <input
            className="square-button-checkbox"
            type="checkbox"
            id={this.inputId}
            // checked={this.optionIsSelected('all')}
            onChange={this.handleClick}
            disabled={this.props.disabled}
            checked={this.props.checked ?? this.props.value?.inputValue}
          />
          {this.props.label ? (
            this.props.href ? (
              <a
                className={
                  (this.props.value.required && !this.props.hideRequired
                    ? 'required '
                    : '') +
                  (this.props.isDownloadLink ? 'is-download-link ' : '')
                }
                href={this.props.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {I18n.t(this.props.label)}
              </a>
            ) : (
              <label
                className={
                  (this.props.value?.required && !this.props.hideRequired
                    ? 'required '
                    : '') +
                  (this.props.isDownloadLink ? 'is-download-link ' : '')
                }
                htmlFor={this.inputId}
              >
                <span className="square-button-label-text">
                  {I18n.t(this.props.label)}
                </span>
              </label>
            )
          ) : null}
          {this.props.description ? (
            <OverlayTrigger
              key={'right'}
              placement={'right'}
              // delayHide={1000000000}
              show={true}
              overlay={
                <Tooltip id={`description-tooltip`}>
                  {this.props.description}
                </Tooltip>
              }
            >
              {this.props.labelBody}
            </OverlayTrigger>
          ) : (
            this.props.labelBody
          )}
        </div>
      </>
    );
  }
}

SquareButton.defaultProps = {};
SquareButton.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.bool,
  change: PropTypes.func,
  setValue: PropTypes.any,
  required: PropTypes.bool,
  isDownloadLink: PropTypes.bool,
  hideRequired: PropTypes.bool,
  style: PropTypes.object,
};

export default SquareButton;
